/**
 * Debug employee record issues
 */
import supabase from '@/lib/supabase';

export async function debugEmployeeRecord(email: string) {
  console.log(`🔍 === EMPLOYEE RECORD DEBUG FOR: ${email} ===`);
  
  try {
    // 1. Try exact match
    console.log('\n1️⃣ Trying exact email match...');
    const { data: exactMatch, error: exactError } = await supabase
      .from('employees')
      .select('*')
      .eq('email', email);
    
    console.log('Exact match result:', { 
      found: exactMatch?.length || 0, 
      error: exactError?.message,
      data: exactMatch 
    });
    
    // 2. Try case-insensitive match
    console.log('\n2️⃣ Trying case-insensitive match...');
    const { data: caseInsensitive, error: caseError } = await supabase
      .from('employees')
      .select('*')
      .ilike('email', email);
    
    console.log('Case-insensitive result:', { 
      found: caseInsensitive?.length || 0, 
      error: caseError?.message,
      data: caseInsensitive 
    });
    
    // 3. Try with trimmed email
    console.log('\n3️⃣ Trying with trimmed email...');
    const { data: trimmed, error: trimError } = await supabase
      .from('employees')
      .select('*')
      .eq('email', email.trim());
    
    console.log('Trimmed result:', { 
      found: trimmed?.length || 0, 
      error: trimError?.message,
      data: trimmed 
    });
    
    // 4. Search by user_id from auth
    console.log('\n4️⃣ Searching by auth user_id...');
    const { data: { session } } = await supabase.auth.getSession();
    if (session?.user?.id) {
      const { data: byUserId, error: userIdError } = await supabase
        .from('employees')
        .select('*')
        .eq('user_id', session.user.id);
      
      console.log('By user_id result:', { 
        userId: session.user.id,
        found: byUserId?.length || 0, 
        error: userIdError?.message,
        data: byUserId 
      });
    }
    
    // 5. List all employees with similar email
    console.log('\n5️⃣ Searching for similar emails...');
    const { data: similar, error: similarError } = await supabase
      .from('employees')
      .select('id, email, user_id, active, national_id')
      .ilike('email', `%${email.split('@')[0]}%`);
    
    console.log('Similar emails found:', { 
      found: similar?.length || 0, 
      error: similarError?.message,
      emails: similar?.map(e => ({
        email: e.email,
        active: e.active,
        hasUserId: !!e.user_id,
        hasNationalId: !!e.national_id
      }))
    });
    
    // 6. Check if .single() is the issue
    console.log('\n6️⃣ Testing .single() vs regular query...');
    const { data: withoutSingle, error: withoutSingleError } = await supabase
      .from('employees')
      .select('*')
      .eq('email', email);
    
    const { data: withSingle, error: withSingleError } = await supabase
      .from('employees')
      .select('*')
      .eq('email', email)
      .single();
    
    console.log('Query comparison:', {
      withoutSingle: { count: withoutSingle?.length, error: withoutSingleError?.message },
      withSingle: { data: withSingle, error: withSingleError?.message }
    });
    
  } catch (error) {
    console.error('Unexpected error:', error);
  }
}

// Export for console use
if (typeof window !== 'undefined') {
  (window as any).debugEmployeeRecord = debugEmployeeRecord;
}